
import { DecimalConfig } from "@/models/dossier-configs/decimal-config";
import { DossierConfigService } from "@/services/dossier-config-service";
import { ProductRow } from "@/utils/product-row";
import { durationToString } from "@/utils/duration";
import Vue from "vue";
import { printDuration, printHumanFloat } from "@/utils/pretty-print";
import {ProductCompositionRow} from "@/models/base";
import {UserConfigService} from "@/services";

export default Vue.extend({
	filters: {
		dToString (value:number) {
			return durationToString(value);
		}
	},
	data() {
		return {
			buttonActions: [
				{text: "Verwijder lijn", value: "remove"},
				{text: this.$ct("insert-row").toString(), value: "insert"},
				{
					text: (this.row.getRowConfig().Bold == true
						? this.$ct("make-regular").toString() : this.$ct("make-bold").toString()),
					value: "bold"
				},
				{text: "hide", value: "hide"}
			],
			dontTriggerSelect: false
		};
	},
	props: {
		isSelected: Boolean,
		row: Object as () => ProductRow,
		rowIndex: {
			type: Number
		}
	},

	computed: {
		displayedProductDescription():String{
			return this.getDisplayedRowProductDescription(this.row.ProductDescription);
		},
		decimalSettings():DecimalConfig {
			return DossierConfigService.getDecimalSettings();
		},
		isBold(): boolean {
			return this.row.getRowConfig().Bold;
		},
		isHidden(): boolean {
			return this.row.getRowConfig().Hidden;
		},
		isSubTotal(): boolean {
			return this.row.getRowConfig().SubTotal;
		},
		netto(): number {
			return this.row.UnitPrice * this.row.Amount * (1 - (this.row.Discount / 100));
		},
		bruto(): number {
			return this.netto * (1 + (this.row.Vat / 100.0));
		},
		options(): any[] {
			let data = [
				{text: "Verwijder lijn", value: "remove"},
				{text: this.$ct("insert-row").toString(), value: "insert"},
			];

			data.push({
					value: "bold",
					text: (this.row.getRowConfig().Bold == true
						? this.$ct("make-regular").toString() : this.$ct("make-bold").toString())
				},
				{
					value: "hide",
					text: (this.row.getRowConfig().Hidden == true
						? this.$ct("row-show").toString() : this.$ct("row-hide").toString())
				});

			return data;
		},
	},
	methods: {
		getDisplayedRowProductDescription(description: string) {
			return description.replaceAll("{__NEW_LINE__}", "<br>").replaceAll("{__DOUBLE_SPACE__}", "&nbsp;&nbsp;");
		},
		onRowClick(){
			if (this.dontTriggerSelect) {
				this.dontTriggerSelect = false;
				return;
			}
			this.selectItem();
			this.onEdit();
		},
		onEdit() {
			this.$emit("edit");
		},
		selectItem() {
			this.$emit("select", this.row);
		},
		onRemove() {
			this.$emit("remove");
		},
		trigger(value: string) {
			this.$emit(value);
		},
		forceSelect(row: ProductRow) {
			this.dontTriggerSelect = true;
			if (!this.isSelected) {
				this.$emit("select", row);
			}
		},
		humanDuration(value:number):string{
			return printDuration(value);
		},
		humanFloat(value:number, decimals:number = 2):string {
			return printHumanFloat(value, decimals);
		}
	},
	mounted(){
		if((this.row as ProductCompositionRow ).ReferencedProduct && UserConfigService.getGeneralSettings().GetPurchasePriceFromProductWhenZero){
			this.row.UnitBuyPrice = ((this.row as ProductCompositionRow ).ReferencedProduct?.BuyNettoPrice) || 0;
		}
	},
	i18nEx: {
		componentPrefix: "components.products-table"
	}
});
